import { ThermometerHot, Drop, ForkKnife, AirplaneTilt } from "@phosphor-icons/react";

const ITEMS = [
  {
    icon: ThermometerHot,
    title: "Temperature fluctuations",
    body: "A kitchen fridge spikes well above the safe range every time the door opens, enough to slowly degrade peptides.",
  },
  {
    icon: Drop,
    title: "Moisture & condensation",
    body: "Humid air condenses on vials and labels, compromising sterility and making dosing unreliable.",
  },
  {
    icon: ForkKnife,
    title: "Food contamination",
    body: "Storing medication next to raw food, sauces and leftovers introduces avoidable cross-contamination risk.",
  },
  {
    icon: AirplaneTilt,
    title: "Not travel friendly",
    body: "The moment you leave home, the cold chain breaks, and with it the confidence that your medication is safe.",
  },
];

export default function ProblemSection() {
  return (
    <section
      data-testid="problem-section"
      className="py-14 sm:py-20 bg-cool-white"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
        <div className="max-w-3xl reveal">
          <div className="overline text-cyan-brand">The Problem</div>
          <h2 className="font-display mt-4 text-4xl md:text-5xl lg:text-[54px] font-bold text-navy-deep tracking-tight leading-[1.05]">
            Why a normal fridge isn&apos;t optimal for medications.
          </h2>
          <p className="mt-6 text-slate-600 text-[17px] leading-relaxed">
            Peptides, insulin and biologics are fragile. Every degree, every
            door opening, every drop of condensation matters. Household fridges
            weren&apos;t built for this.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {ITEMS.map((it) => (
            <div
              key={it.title}
              className="reveal rounded-3xl bg-white border border-[#8A97A8]/25 p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_-24px_rgba(2,47,107,0.25)]"
            >
              <div className="h-12 w-12 rounded-2xl bg-cool-white border border-[#8A97A8]/20 grid place-items-center text-royal">
                <it.icon size={22} weight="regular" />
              </div>
              <h3 className="mt-5 text-navy-deep font-display font-bold text-lg">
                {it.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-[14.5px]">
                {it.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
